import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';

import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { ApiVanillaService } from '../../../lazy-modules/serviceClosure/api-vanilla.service';
import { LoadingOverlayComponent } from '../../../shared/components/loadingOverlay/loading-overlay.component';

@Component({
    selector: 'srm-loading-overlay',
    templateUrl: 'loading-overlay-srm.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule],
})
export class SRMLoadingOverlayComponent extends LoadingOverlayComponent {
    override readonly NAME: string = 'SRMLoadingOverlay';

    constructor(
        protected override pubsub: PubSubService,
        protected override changeDetectorRef: ChangeDetectorRef,
        public override apiVanillaService: ApiVanillaService,
    ) {
        super(pubsub, changeDetectorRef, apiVanillaService);
    }

    override ngOnDestroy(): void {
        this.pubsub.unsubscribe(this.NAME);
    }
}
